/**
 * DIFFY PREMIUM SCRIPT - V8 FINAL (ARQUITETURA BLINDADA)
 * - Trava de Fundo via CSS Fixed
 * - Prevenção de Event Stacking (Vazamento de Memória)
 * - Cálculo Exato de Largura (Evita pulos)
 */
document.addEventListener("DOMContentLoaded", function() {
  

  let isAnimating = false;
  let touchStartX = 0;
  let touchEndX = 0;
  let savedScrollPosition = 0;
  let galeriaAtual = null; // Guarda a referência da galeria aberta

  // --- 1. FUNÇÃO DE CONTROLE (INJEÇÃO VISUAL) ---
  function controlarZoomDiffy(modal) {
    galeriaAtual = modal.querySelector('.dialog-zoomed-gallery');
    if (!galeriaAtual) return;

    // Injeta Setas se não existirem
    if (!modal.querySelector('.diffy-spigen-nav')) {
      const nav = document.createElement('div');
      nav.className = 'diffy-spigen-nav';
      nav.innerHTML = `
        <button type="button" class="s-btn s-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg></button>
        <button type="button" class="s-btn s-close"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg></button>
        <button type="button" class="s-btn s-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg></button>
      `;

      const btnStyle = {
        width: '56px', height: '56px', borderRadius: '50%', border: 'none',
        background: 'white', color: 'black', cursor: 'pointer',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)', display: 'flex', 
        alignItems: 'center', justifyContent: 'center'
      };
      nav.querySelectorAll('.s-btn').forEach(b => Object.assign(b.style, btnStyle));
      modal.appendChild(nav);

      // Eventos dos botões (Usando querySelector para segurança)
      nav.querySelector('.s-next').addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); moverSlide('next'); });
      nav.querySelector('.s-prev').addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); moverSlide('prev'); });
      nav.querySelector('.s-close').addEventListener('click', (e) => { 
        e.preventDefault(); 
        const closeTheme = modal.querySelector('.dialog-zoomed-gallery__close-button');
        if(closeTheme) closeTheme.click();
        else modal.closest('dialog').close();
      });
    }
  }

  // --- 2. MOTOR DE MOVIMENTO ---
  function moverSlide(direcao) {
    if (isAnimating || !galeriaAtual) return;
    isAnimating = true; 
    galeriaAtual.style.pointerEvents = 'none'; 
    
    // CÁLCULO EXATO: Evita que a galeria pule imagens
    const largura = galeriaAtual.clientWidth;
    const scrollAtual = galeriaAtual.scrollLeft;
    const novaPosicao = direcao === 'next' ? scrollAtual + largura : scrollAtual - largura;
    
    galeriaAtual.scrollTo({ left: novaPosicao, behavior: 'smooth' });
    
    setTimeout(() => { isAnimating = false; galeriaAtual.style.pointerEvents = 'auto'; }, 400);
  }

  // --- 3. EVENTOS GLOBAIS (FORA DA FUNÇÃO PARA NÃO DUPLICAR) ---
  
  // Bloqueio de Mouse e Scroll (PC)
  window.addEventListener('mousedown', function(e) {
    if (document.body.classList.contains('modal-open') && e.button === 1) { e.preventDefault(); return false; }
  }, { passive: false });

  window.addEventListener('wheel', function(e) {
    if (document.body.classList.contains('modal-open')) {
      e.preventDefault(); e.stopPropagation();
      if (isAnimating) return;
      if (e.deltaY > 0 || e.deltaX > 0) moverSlide('next');
      else if (e.deltaY < 0 || e.deltaX < 0) moverSlide('prev');
    }
  }, { passive: false });

  // Swipe Mobile (Ouvindo o documento inteiro, mas agindo só na galeria)
  document.addEventListener('touchstart', (e) => { 
    if (document.body.classList.contains('modal-open') && e.target.closest('.dialog-zoomed-gallery')) {
      touchStartX = e.changedTouches[0].screenX; 
    }
  }, {passive: true});

  document.addEventListener('touchend', (e) => {
    if (document.body.classList.contains('modal-open') && e.target.closest('.dialog-zoomed-gallery')) {
      touchEndX = e.changedTouches[0].screenX;
      if (isAnimating) return;
      const swipeDistance = touchEndX - touchStartX;
      if (swipeDistance < -40) moverSlide('next');
      else if (swipeDistance > 40) moverSlide('prev');
    }
  }, {passive: true});


  // --- 4. O SEGREDO DO SCROLL (BLINDADO CONTRA APPS) ---
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.target && m.target.classList && m.target.classList.contains('dialog-zoomed-gallery__dialog')) {
        
        if (m.target.hasAttribute('open')) {
          // [ABRINDO]
          if (document.body.classList.contains('modal-open')) return; 
          
          savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
          
          document.body.style.position = 'fixed';
          document.body.style.top = `-${savedScrollPosition}px`;
          document.body.style.width = '100%';
          
          document.body.classList.add('modal-open');
          document.documentElement.classList.add('modal-open');
          
          setTimeout(() => controlarZoomDiffy(m.target), 50);
          
        } else {
          // [FECHANDO]
          if (!document.body.classList.contains('modal-open')) return;

          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          
          document.body.classList.remove('modal-open');
          document.documentElement.classList.remove('modal-open');
          
          window.scrollTo(0, savedScrollPosition);
          
          isAnimating = false;
          galeriaAtual = null; // Limpa a referência
          const nav = document.querySelector('.diffy-spigen-nav');
          if(nav) nav.remove();
        }
      }
    });
  });

  observer.observe(document.body, { 
    attributes: true, 
    subtree: true, 
    attributeFilter: ['open'] 
  });
  

});

